import api from '../axiosConfig';

const nonempty = value => typeof value === 'string' && value.trim() !== '';
const normalizedName = value => {
  const name = String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  return ['bogota', 'bogotadc', 'bogotadistritocapital'].includes(name) ? 'bogota' : name;
};

export function matchMunicipality(location, departments, cities) {
  if (!/^\d{5}$/.test(location.municipality_code || '') || !nonempty(location.municipality) || !nonempty(location.state)) return null;
  const matches = departments.filter(d => normalizedName(d.nombre) === normalizedName(location.state));
  if (matches.length !== 1) return null;
  const department = matches[0];
  const candidates = cities.filter(c => Number(c.departamento_id) === Number(department.id)
    && normalizedName(c.nombre) === normalizedName(location.municipality)
    && (!c.codigo_dane || String(c.codigo_dane).padStart(5, '0') === location.municipality_code));
  if (candidates.length !== 1) return null;
  // Catalog IDs are not DANE codes. Require a unique municipality AND department match.
  return {department, city:candidates[0], municipality_code:location.municipality_code, method:'name_and_department'};
}

let catalogs;
export async function withMunicipalityMatch(location) {
  if (location.provider !== 'megatrack' || !location.municipality_code || !location.municipality || !location.state) return location;
  try {
    if (!catalogs) catalogs = Promise.all([api.get('/departamentos'), api.get('/ciudades')]).then(responses => responses.map(r => {
      const rows = Array.isArray(r.data) ? r.data : r.data?.data;
      if (!Array.isArray(rows)) throw new Error('Catálogo no disponible.');
      return rows;
    })).catch(error => {catalogs = null;throw error;});
    const [departments, cities] = await catalogs;
    return {...location, catalog_match:matchMunicipality(location, departments, cities)};
  } catch {
    return {...location, catalog_match:null};
  }
}

export function physicalAddress(location) {
  return location.provider === 'megatrack' ? location.street_address || null : location.short_address || location.address || null;
}

// Missing provider data never erases a manual field. Coordinates always identify the selected point.
export function selectedLocationFields(address, locality, coordinates, details = {}, prefix = '') {
  const fields = {[`${prefix}coordenadas`]:coordinates};
  if (nonempty(address)) fields[`${prefix}direccion`] = address;
  if (nonempty(locality)) fields[`${prefix}localidad`] = locality;
  if (nonempty(details?.neighborhood)) fields[`${prefix}barrio`] = details.neighborhood;
  return fields;
}

export function municipalityFields(details, prefix = '', suffixed = true) {
  const match = details?.catalog_match;
  if (!match) return {};
  return {[`${prefix}departamento${suffixed?'_id':''}`]:match.department.id, [`${prefix}ciudad${suffixed?'_id':''}`]:match.city.id};
}
